/**
 * Update target object with source fields,
 * tailored for valtio
 */
export function deepMerge<T>(target: T, source: any): void {
  for (const key in source) {
    const value = source[key];
    if (
      Array.isArray(value) ||
      typeof value !== 'object' ||
      !(target as any)[key]
    ) {
      (target as any)[key] = value;
      continue;
    }

    // value is object
    deepMerge((target as any)[key], value);
  }
}

/**
 * Deep clone object without methods, getter and setters,
 * tailored for valtio
 * */
export function deepClone<T extends object>(target: T): T {
  if (!target) {
    return target;
  }

  const keys = Object.keys(target).filter(key => isPlainField(target, key));

  const result: any = {};
  for (const key of keys) {
    const value = (target as any)[key];
    if (Array.isArray(value) || typeof value !== 'object') {
      result[key] = value;
      continue;
    }

    // value is object
    result[key] = deepClone(value);
  }

  return result;
}

/**
 * Determine if object field is simple field,
 * in other terms not a method, getter or setter
 */
export const isPlainField = (target: object, key: string): boolean => {
  const desc = Object.getOwnPropertyDescriptor(target, key);
  if (!desc) {
    // if it not exists, then probably it is plain
    return true;
  }

  // if it getter or setter
  if (desc.get || desc.set) {
    return false;
  }

  // is it value function, then it is method
  return typeof desc.value !== 'function';
};
